import { accordionOpen } from 'store/ui/uiActions';
import { createAccordionOpenEvent } from '../eventCreators';
import { createAccordionOpenEventPayload } from '../dataHelpers/createAccordionOpenEventPayload';

const emitAccordionOpenEvent = ({ payload }) => {
  const accordionOpenEvent = createAccordionOpenEvent(
    createAccordionOpenEventPayload({
      groupName: payload.groupName,
      itemName: payload.itemName,
    }),
  );
  return accordionOpenEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [accordionOpen]: emitAccordionOpenEvent };
